import type { FunctionComponent } from 'react';

export enum OnboardingUserRole {
  STORE_OWNER = 'STORE_OWNER',
  ECOMMERCE_MANAGER = 'ECOMMERCE_MANAGER',
  CRO_CONSULTANT = 'CRO_CONSULTANT',
  IN_HOUSE_MARKETER = 'IN_HOUSE_MARKETER',
  OTHER = 'OTHER',
}

export enum OnboardingUserScenario {
  TWO_VERSIONS_LANDING_PAGE = 'TWO_VERSIONS_LANDING_PAGE',
  TWO_VERSIONS_ADVERTORIAL_PAGE = 'TWO_VERSIONS_ADVERTORIAL_PAGE',
  TWO_VERSIONS_HOME_PAGE = 'TWO_VERSIONS_HOME_PAGE',
  SHOPIFY_PRODUCT_PAGE_VS_CUSTOM_PRODUCT_PAGE = 'SHOPIFY_PRODUCT_PAGE_VS_CUSTOM_PRODUCT_PAGE',
  LANDING_PAGE_VS_PRODUCT_PAGE = 'LANDING_PAGE_VS_PRODUCT_PAGE',
  TWO_DIFFERENT_FLOWS_LANDING_TO_PRODUCT_PAGE = 'TWO_DIFFERENT_FLOWS_LANDING_TO_PRODUCT_PAGE',
  NEW_VS_CURRENT_WEBSITE_DESIGN = 'NEW_VS_CURRENT_WEBSITE_DESIGN',
  DIFFERENT_LAYOUT_FOR_A_PRODUCT = 'DIFFERENT_LAYOUT_FOR_A_PRODUCT',
  NONE_OF_THESE_ABOVE = 'NONE_OF_THESE_ABOVE',
}

export type OnboardingQuestionValue = OnboardingUserRole | OnboardingUserScenario;
export interface IOnboardingQuestion {
  label: string;
  value: OnboardingQuestionValue | null;
  isSelected: boolean;
  icon?: FunctionComponent;
  isOther?: boolean;
}

export interface IOnboardingStep {
  step: number;
  title: string;
  description: string;
  isMultipleChoice: boolean;
  questionList: IOnboardingQuestion[];
  // Marks a non-question step rendered as the "Enable Theme Helper" card instead of an option list.
  isEnableThemeHelper?: boolean;
}

export interface IOnboardingQuestionValues {
  step: number;
  values: OnboardingQuestionValue[];
}

export interface IOnboardingOtherQuestionValue {
  step: number;
  value: string | null;
}

export interface IOnboardingData<T = string, K = string> {
  // Survey
  currentStepSurvey: number;
  userRole: T;
  userScenario: K;
  selectedOthers: { role: boolean; scenario: boolean };
  // Setup Guide
  campaignId: string;
  campaignGroupId: string;
  currentStepSetup: number | null;
  splitUserTrafficRangeValue: number;
  isDoneSurvey: boolean;
  isDoneSetupGuide: boolean;
}

export enum IOnboardingStatus {
  NONE = 'none',
  DONE_SURVEY = 'done-survey',
  DONE_SETUP_GUIDE = 'done-setup-guide',
}
